import * as moment from 'moment/moment'

export default {
  methods: {
    async getBiometricLogs() {
      if (!this.startDate) {
        return
      }
      this.biometricLoader = true
      try {
        const input = typeof this.user_id === 'object'
          ? {
            date: moment(this.startDate).format('YYYY-MM-DD'),
            user_id: this.userInfo.id,
          }
          : {
            date: moment(this.startDate).format('YYYY-MM-DD'),
            user_id: this.user_id,
          }

        if (this.userInfo.role == 'EMP' && this.userInfo.id !== this.user_id) {
          input.is_show_other_record = true
        }

        const response = await this.getHTTPPostResponse(
          'clock-in-out/biometric-logs',
          input,
          false,
        )
        if (response && response.data) {
          const { data } = response
          this.biometricData = data.biometric_logs || []
          this.biometricTotalTime = data.total_time || '00:00'
        }
      } finally {
        this.biometricLoader = false
      }
    },
  }
}
